import { createHashHistory } from 'history'
import moment from 'moment'
import AuthAPI from 'services/login'
import { notification } from 'antd'
import Scopes from 'services/scope'
import axios from 'axios'
import Conf from 'ui-config'
import { AES, enc } from 'crypto-js'
import ClusterService from './cluster_apis'

// import store from 'store'
import RouteAccess from './route_access'

export const Common = {
  version: 'v9.7.2',
  productName: 'Bloo',
  nativeAuthor: 'Bloo',
  poweredBy: 'DNIF',
  ktext: 'g3tTheFe3l0f1t',
  rtext: 'let5g3tth1sd0n3',

  copyMessage: function() {
    Common.showNotifications('info', 'Copied to clipboard')
  },

  pasteMessage: function() {
    // Common.showNotifications('info', 'Copied to clipboard')
  },

  CopyFunction: function(statecopy) {
    navigator.clipboard.writeText(statecopy)
    this.copyMessage()
  },

  pasteFunction: function(callBackFunction) {
    navigator.clipboard
      .readText()
      .then(pastedText => {
        callBackFunction(pastedText)
      })
      .catch(err => {
        console.error('Failed to read clipboard contents: ', err)
      })
    // this.pasteMessage()
  },

  sortDataByTime: function(data, field) {
    let sorted_data = []
    sorted_data = data.sort((a, b) => parseFloat(b[field]) - parseFloat(a[field]))
    return sorted_data
  },

  getAggregateValue: function(arrData, valField, zValue) {
    let p = 0,
      sum = 0
    let zValues = []
    for (p; p < arrData.length; p++) {
      sum = sum + arrData[p][valField]
      if (zValue !== null && zValues.indexOf(arrData[p][zValue]) === -1) {
        zValues[zValues.length] = arrData[p]
      }
      if (p === arrData.length - 1) {
        return { sum: sum, zValues: zValues }
      }
    }
  },

  getMaxUnit: function(arrData, valField, isByte) {
    var max = 0,
      unit = ''
    for (var i = 0; i < arrData.length; i++) {
      if (arrData[i][valField] !== null && arrData[i][valField] > max) {
        max = arrData[i][valField]
      }
      if (i === arrData.length - 1) {
        if (isByte) {
          if (max >= 1000000000000000) {
            unit = `P`
          } else if (max >= 1000000000000) {
            unit = `T`
          } else if (max >= 1000000000) {
            unit = `G`
          } else if (max >= 1000000) {
            unit = `M`
          } else if (max >= 1000) {
            unit = `K`
          } else {
            unit = `B`
          }
        } else {
          if (max >= 1000000000000) {
            unit = `T`
          } else if (max >= 1000000000) {
            unit = `B`
          } else if (max >= 1000000) {
            unit = `M`
          } else if (max >= 1000) {
            unit = `K`
          } else {
            unit = ``
          }
        }
        return unit
      }
    }
  },
  getMaxUnit2: function(arrData, valField, isByte) {
    var max = 0,
      unit = ''
    for (var i = 0; i < arrData.length; i++) {
      if (arrData[i][valField] > max) {
        max = arrData[i][valField]
      }
      if (i === arrData.length - 1) {
        if (isByte) {
          if (max >= 1000000000000000) {
            unit = `PB`
          } else if (max >= 1000000000000) {
            unit = `TB`
          } else if (max >= 1000000000) {
            unit = `GB`
          } else if (max >= 1000000) {
            unit = `MB`
          } else if (max >= 1000) {
            unit = `KB`
          } else {
            unit = `B`
          }
        } else {
          if (max >= 1000000000000) {
            unit = `T`
          } else if (max >= 1000000000) {
            unit = `B`
          } else if (max >= 1000000) {
            unit = `M`
          } else if (max >= 1000) {
            unit = `K`
          } else {
            unit = ``
          }
        }
        return unit
      }
    }
  },
  bytesToSize: function(value, unit) {
    if (value !== undefined && value !== null) {
      if (unit === `P`) {
        return +((value / 1000000000000000).toFixed(2) === '0.00'
          ? (value / 1000000000000000).toFixed(4)
          : (value / 1000000000000000).toFixed(2))
      } else if (unit === `T`) {
        return +((value / 1000000000000).toFixed(2) === '0.00'
          ? (value / 1000000000000).toFixed(4)
          : (value / 1000000000000).toFixed(2))
      } else if (unit === `G`) {
        return +((value / 1000000000).toFixed(2) === '0.00'
          ? (value / 1000000000).toFixed(4)
          : (value / 1000000000).toFixed(2))
      } else if (unit === `M`) {
        return +((value / 1000000).toFixed(2) === '0.00'
          ? (value / 1000000).toFixed(4)
          : (value / 1000000).toFixed(2))
      } else if (unit === `K`) {
        return +((value / 1000).toFixed(2) === '0.00'
          ? (value / 1000).toFixed(4)
          : (value / 1000).toFixed(2))
      } else if (unit === `B`) {
        return +(value.toFixed(2) === '0.00' ? value.toFixed(4) : value.toFixed(2))
      }
    }
  },
  bytesToSize2: function(value, unit) {
    if (value !== undefined && value !== null) {
      if (unit === `PB`) {
        return +((value / 1000000000000000).toFixed(2) === '0.00'
          ? (value / 1000000000000000).toFixed(4)
          : (value / 1000000000000000).toFixed(2))
      } else if (unit === `TB`) {
        return +((value / 1000000000000).toFixed(2) === '0.00'
          ? (value / 1000000000000).toFixed(4)
          : (value / 1000000000000).toFixed(2))
      } else if (unit === `GB`) {
        return +((value / 1000000000).toFixed(2) === '0.00'
          ? (value / 1000000000).toFixed(4)
          : (value / 1000000000).toFixed(2))
      } else if (unit === `MB`) {
        return +((value / 1000000).toFixed(2) === '0.00'
          ? (value / 1000000).toFixed(4)
          : (value / 1000000).toFixed(2))
      } else if (unit === `KB`) {
        return +((value / 1000).toFixed(2) === '0.00'
          ? (value / 1000).toFixed(4)
          : (value / 1000).toFixed(2))
      } else if (unit === `B`) {
        return +(value.toFixed(2) === '0.00' ? value.toFixed(4) : value.toFixed(2))
      }
    }
  },

  convertNumber: function(value, unit) {
    if (value !== undefined && value !== null && unit !== undefined) {
      if (unit === `T`) {
        return +(value / 1000000000000).toFixed(2)
      } else if (unit === `B`) {
        return +(value / 1000000000).toFixed(2)
      } else if (unit === `M`) {
        return +(value / 1000000).toFixed(2)
      } else if (unit === `K`) {
        return +(value / 1000).toFixed(2)
      } else {
        return +value.toFixed(2)
      }
    } else {
      return 0
    }
  },

  formatNumber: function(labelValue) {
    // Nine Zeroes for Billions
    let val = ''
    if (Math.abs(Number(labelValue)) >= 1.0e9) {
      val = (Math.abs(Number(labelValue)) / 1.0e9).toString().slice(0, 4) + 'B'
    } else if (Math.abs(Number(labelValue)) >= 1.0e6) {
      val = (Math.abs(Number(labelValue)) / 1.0e6).toString().slice(0, 4) + 'M'
    } else if (Math.abs(Number(labelValue)) >= 1.0e3) {
      val = (Math.abs(Number(labelValue)) / 1.0e3).toString().slice(0, 4) + 'K'
    } else val = Math.abs(Number(labelValue))

    return val
  },

  getUnit: function(val) {
    if (val >= 1000000000000) {
      return +(val / 1000000000000).toFixed(1) + 'T'
    } else if (val >= 1000000000) {
      return +(val / 1000000000).toFixed(1) + 'B'
    } else if (val >= 1000000) {
      return +(val / 1000000).toFixed(1) + 'M'
    } else if (val >= 1000) {
      return +(val / 1000).toFixed(1) + 'K'
    } else {
      return val
    }
  },

  getNotesTime: function(data) {
    var timeStr = moment.unix(data).fromNow()
    return timeStr
  },

  getformatedTime: function(date, type) {
    var timeStr
    if (type === 'relative') {
      timeStr = moment(date)
        .startOf('ymd')
        .fromNow()
    } else if (type === 'preciseRelative') {
      if (!date) return '_'

      // 1. Same logic as your Age column
      var now = Date.now()
      var startMs = date < 10000000000 ? date * 1000 : date
      var diffInSec = (now - startMs) / 1000

      if (diffInSec < 60) return 'Just now'

      var minutes = Math.floor(diffInSec / 60)
      var hours = Math.floor(minutes / 60)
      var days = Math.floor(hours / 24)

      if (days > 0) return days + (days === 1 ? ' day ago' : ' days ago')
      if (hours > 0) return hours + (hours === 1 ? ' hour ago' : ' hours ago')
      if (minutes > 0) return minutes + (minutes === 1 ? ' minute ago' : ' minutes ago')

      return 'Just now'
    } else if (type === 'LongDate') {
      timeStr = moment(moment(new Date(date * 1000) / 1000).format('YYYY-MM-DDTHH:mm:ss')).format(
        'D MMM YYYY, h:mm:ss A',
      )
    } else if (type === 'DateTime') {
      timeStr = moment(moment(new Date(date * 1000) / 1000).format('YYYY-MM-DDTHH:mm:ss')).format(
        'D/M/Y H:mm:ss',
      )
    } else if (type === 'Last') {
      var num, str
      // var seconds = new Date(date)?.getSeconds()
      var data = moment(date)
        .startOf('ymd')
        .fromNow()
      // str = data.replace('ago', '')
      // if (seconds === 0) {
      //   var minutes = new Date(data)?.getMinutes()
      //   if (minutes > 0) console.log('yes')
      //   console.log(data, minutes)
      // } else
      if (data === 'a few seconds ago') {
        timeStr = data
      } else if (data.includes('a ')) {
        str = data.replace('ago', '')
        num = 1
        str = str.replace('a', '')
        str = str.replace(/[0-9]/g, '')
        timeStr = ['Last ', num, str]
      } else if (data.includes('an ')) {
        str = data.replace('ago', '')
        num = 1
        str = str.replace('an', '')
        str = str.replace(/[0-9]/g, '')
        timeStr = ['Last ', num, str]
      } else {
        str = data.replace('ago', '')
        num = parseInt(data)
        str = str.replace(/[0-9]/g, '')
        timeStr = ['Last ', num, str]
      }
    } else if (type === 'MonthDayYear') {
      return moment(moment(new Date(date * 1000) / 1000).format('YYYY-MM-DDTHH:mm:ss')).format(
        'MMMM D, YYYY',
      )
    }
    return timeStr
  },

  getshortTime: function(data) {
    var timeStr = moment.unix(data).format('LT')
    return timeStr
  },

  getArrayDuration: function(starttime, endtime, partition) {
    var duration = 'minutes'
    partition ? (duration = partition) : (duration = 'minutes')
    var startStr = moment(moment(new Date(starttime * 1000) / 1000).format('YYYY-MM-DDTHH:mm:ss'))
    var endStr = moment(moment(new Date(endtime * 1000) / 1000).format('YYYY-MM-DDTHH:mm:ss'))
    var arr = []
    while (startStr.isBefore(endStr, duration)) {
      var formatData = new Date(startStr.format('D MMM YYYY, h:mm A'))
      arr.push({
        epocVal: formatData.getTime() / 1000.0,
        formattedTime: startStr.format('D MMM YYYY, h:mm A'),
      })
      startStr.add(1, duration)
    }
    return arr
  },

  convertTSToMilliSec: function(ts) {
    let ts_str = parseInt(ts) + ''

    let isMilliseconds = ts_str.length > 10

    return isMilliseconds ? ts : ts * 1000
  },

  encryptData: function(data, flag) {
    var convertedStr = flag ? data : JSON.stringify(data)
    var readyStr = AES.encrypt(this.ktext + convertedStr, this.rtext).toString()
    return readyStr
  },

  decryptData: function(ciphertext, flag) {
    if (ciphertext !== null) {
      var bytes = AES.decrypt(ciphertext, this.rtext)
      var decryptedData = bytes.toString(enc.Utf8)
      var data = decryptedData.substring(this.ktext.length, decryptedData.length)
      return flag ? data : JSON.parse(data)
    } else {
      return null
    }
  },

  getCurrentUser: function(data) {
    let name = localStorage.getItem('name')
    let emailId = localStorage.getItem('email')
    for (let i = 0; i < data.length; i++) {
      if (name === data[i]['name'] && emailId === data[i]['email_id']) {
        return data[i]['user_id']
      }
    }
  },

  exportData: async function(apiCall) {
    return await apiCall
      .then(response => {
        if (response.data.status === 'invalid') {
          Common.sessionExpiry()
          return null
        } else if (response.data.status === 'failed') {
          if (response.data.message === 'user not authorised') {
            Common.UpdateUI_withNewAccess()
          } else {
            Common.showNotifications('error', 'Something went wrong')
          }
          return null
        } else {
          return response.data.data
        }
      })
      .catch(err => {
        Common.showNotifications(
          'error',
          err?.response?.data?.message ? err?.response?.data?.message : 'Something went wrong',
        )
        return null
      })
  },

  sessionExpiry: function(val) {
    const history = createHashHistory()
    var status = localStorage.getItem('IsInvalid')
    if (history.location.pathname !== '/auth/login') {
      var historyURLmain = history.location.pathname + history.location.search
    } else {
    }
    localStorage.setItem('historyURL', historyURLmain)
    var userPayload = JSON.parse(localStorage.getItem('userPayload'))
    if (userPayload === null) {
      setTimeout(() => {
        history.push('/auth/login')
      }, 100)
    }
    if (history.location.pathname !== '/auth/login') {
      status = false
    }
    if (history.location.pathname !== '/auth/login' && (status === false || status === 'false')) {
      localStorage.setItem('IsInvalid', true)
      localStorage.setItem('accessData', JSON.stringify([]))
      var ssid = localStorage.getItem('SSID')
      let input = {
        SSID: ssid,
      }
      if (val === 'access') {
        notification.error({
          message: 'Session expired. Redirecting to login',
          className: 'sessionOut',
        })
      }
      return AuthAPI.invalidate({
        SSID: ssid,
        clusterId: userPayload.selectedCluster.clusterId,
      })
        .then(response => {
          localStorage.setItem('SSID', '')
          localStorage.setItem('email', '')
          var historyURL = localStorage.getItem('historyURL')
          localStorage.clear()
          sessionStorage.clear()
          localStorage.setItem('historyURL', historyURL)

          // setTimeout(() => {
          //   history.push('/auth/login')
          // }, 100)

          return AuthAPI.logout(JSON.stringify(input))
            .then(response => {
              localStorage.setItem('SSID', '')
              localStorage.setItem('email', '')
              var historyURL = localStorage.getItem('historyURL')
              localStorage.clear()
              sessionStorage.clear()
              localStorage.setItem('historyURL', historyURL)
            })
            .catch(err => {
              var historyURL = localStorage.getItem('historyURL')
              localStorage.clear()
              sessionStorage.clear()
              localStorage.setItem('historyURL', historyURL)
              history.push('/auth/login')
            })
        })
        .catch(err => {
          localStorage.setItem('SSID', '')
          localStorage.setItem('email', '')
          var historyURL = localStorage.getItem('historyURL')
          localStorage.clear()
          sessionStorage.clear()
          localStorage.setItem('historyURL', historyURL)

          setTimeout(() => {
            history.push('/auth/login')
          }, 100)
        })
    }
  },

  showNotifications: function(status, msg, description, duration) {
    return notification[status]({
      placement: 'bottomRight',
      // duration: status !== 'error' ? 4 : 0,
      duration: duration ? duration : 4,
      message: msg,
      description: description ? description : '',
    })
  },

  getMaxTotalCount: function(data, pField, sField, countField) {
    const primaryFields = new Set()
    const fieldMapping = {}

    for (const item of data) {
      const primaryKey = item[pField]
      const secondaryField = item[sField]
      const count = item[countField]

      if (!primaryFields.has(primaryKey)) {
        primaryFields.add(primaryKey)
        fieldMapping[primaryKey] = { sFields: [secondaryField], count }
      } else {
        fieldMapping[primaryKey].sFields.push(secondaryField)
        fieldMapping[primaryKey].count += count
      }
    }

    let maxKey = null
    let maxCount = 0
    for (const [key, value] of Object.entries(fieldMapping)) {
      if (value.count > maxCount) {
        maxCount = value.count
        maxKey = key
      }
    }

    return { maxKey, maxCount }
  },

  generateTimeRange: function(startTime, endTime, timeslice) {
    var result = [moment(startTime)]
    while (startTime !== endTime) {
      var start = moment(startTime).add(1, timeslice)
      result.push(start)
    }
  },

  getScope: function() {
    let urlscope = window.location.hash.replace('#/', '').split('/')[1]
    let selectedScope = JSON.parse(sessionStorage.getItem('SelectedScope'))
    let SelectedCluster = this.getSelectedCluster()
    if (SelectedCluster !== null) {
      SelectedCluster['scope_access'].map(scope => {
        if (scope.scope_id === urlscope) {
          sessionStorage.setItem('SelectedScope', JSON.stringify(scope))
          selectedScope = scope
        }
        return selectedScope
      })
    }
  },

  getUserAcc: function(type) {
    let selectedCluster = {}
    let selectedScope = {}
    let accRole = ''
    var data = { ssid: localStorage.getItem('SSID') }
    if (localStorage.getItem('SSID') !== null) {
      Scopes.getUserAccessDetails(data, localStorage.getItem('SSID')).then(response => {
        if (
          response.data.status === 'invalid' ||
          (response.data.status === 'error' &&
            (response.data.message === 'User Invalid' || response.data.message === 'Invalid'))
        ) {
          Common.sessionExpiry()
        }
        if (response.data.status === 'success') {
          var responseData = response.data
          for (let i = 0; i < responseData.data.access.length; i++) {
            if (
              responseData.data.access[i].clusterId ===
              window.location.hash.replace('#/', '').split('/')[0]
            ) {
              selectedCluster = responseData.data.access[i]
              for (let j = 0; j < responseData.data.access[i].scope_access.length; j++) {
                if (
                  responseData.data.access[i].scope_access[j].scope_id ===
                  window.location.hash.replace('#/', '').split('/')[1]
                ) {
                  selectedScope = responseData.data.access[i].scope_access[j]
                }
              }
            } else {
              if (localStorage.getItem('IsInvalid') === false) {
                selectedCluster = responseData.data.access[0]
                selectedScope =
                  responseData.data.access[0].scope_access.length > 0
                    ? responseData.data.access[0].scope_access[0]
                    : {}
                break
              }
            }
          }
          var enabledScopelist = response.data.data
          for (
            let i = 0;
            i < enabledScopelist.access.length && enabledScopelist.access.length > 0;
            i++
          ) {
            if (!enabledScopelist.isAdmin) {
              accRole = 'User - No Access'
              if (enabledScopelist.access[i].access_type !== 'No Access') {
                for (
                  let j = 0;
                  j < enabledScopelist.access[i].scope_access.length &&
                  enabledScopelist.access[i].scope_access.length > 0;
                  j++
                ) {
                  if (
                    enabledScopelist.access[i].access_type === 'Custom' &&
                    enabledScopelist.access[i]['scope_access'][j]['role'] !== 'No Access'
                  ) {
                    accRole = 'User - ' + enabledScopelist.access[i].scope_access[j]['role']
                    break
                  } else if (
                    enabledScopelist.access[i]['scope_access'][j]['role'] !== 'No Access'
                  ) {
                    accRole = 'User - ' + enabledScopelist.access[i].access_type
                    break
                  } else {
                    accRole = 'User - No Access'
                  }
                }
              }
            } else {
              accRole = 'Admin - No Access'
              for (
                let j = 0;
                j < enabledScopelist.access[i].scope_access.length &&
                enabledScopelist.access[i].scope_access.length > 0;
                j++
              ) {
                if (enabledScopelist.access[i].access_type !== 'No Access') {
                  if (
                    enabledScopelist.access[i].access_type === 'Custom' &&
                    enabledScopelist.access[i]['scope_access'][j]['role'] !== 'No Access'
                  ) {
                    accRole = 'Admin - ' + enabledScopelist.access[i].scope_access[j]['role']
                    break
                  } else if (
                    enabledScopelist.access[i]['scope_access'][j]['role'] !== 'No Access'
                  ) {
                    accRole = 'Admin - ' + enabledScopelist.access[i].access_type
                    break
                  } else {
                    accRole = 'Admin - No Access'
                  }
                }
              }
            }
          }
        }
      })
    }
    var userDetails = {
      Cluster: selectedCluster,
      Scope: selectedScope,
      UserAcc: accRole,
    }
    return userDetails
  },

  getSelectedCluster: function() {
    let urlclusterId = window.location.hash.replace('#/', '').split('/')[0]
    let selectedCluster = JSON.parse(sessionStorage.getItem('SelectedCluster'))

    let clusterData = this.getClusterData()
    if (clusterData !== null) {
      clusterData.map(cluster => {
        if (cluster.clusterId === urlclusterId) {
          sessionStorage.setItem('SelectedCluster', JSON.stringify(cluster))
          selectedCluster = cluster
        }
      })
    }

    return selectedCluster
  },

  getClusterData: function() {
    let clusterData = JSON.parse(sessionStorage.getItem('Clusters'))
    if (clusterData === null) {
      clusterData = JSON.parse(localStorage.getItem('Clusters'))
      sessionStorage.setItem('Clusters', JSON.stringify(clusterData))
    }
    return clusterData
  },

  getScopeList: function() {
    let scopeList = this.getSelectedCluster()
    if (scopeList !== null) {
      return scopeList['scope_access']
    } else {
      return scopeList
    }
  },

  getEnabledScopes: function() {
    let urlclusterId = window.location.hash.replace('#/', '').split('/')[0]
    let scopeList = JSON.parse(localStorage.getItem('EnabledScopes'))
    if (scopeList === null) {
      scopeList = JSON.parse(localStorage.getItem('EnabledScopes'))
      sessionStorage.setItem('EnabledScopes', JSON.stringify(scopeList))
    }
    return scopeList
  },

  getUserPayload: function() {
    let urlclusterId = window.location.hash.replace('#/', '').split('/')[0]
    let urlscope = window.location.hash.replace('#/', '').split('/')[1]
    let userPayload = JSON.parse(localStorage.getItem('userPayload'))
    let clusterData = this.getClusterData()
    if (clusterData !== null) {
      clusterData.map(cluster => {
        if (cluster.clusterId === urlclusterId) {
          cluster['scope_access'].map(scope => {
            if (scope.scope_id === urlscope) {
              if (userPayload.role.includes('OrgAdmin')) {
                userPayload.role = 'OrgAdmin - ' + scope.role
              } else if (userPayload.role.includes('Root')) {
                userPayload.role = 'Root - ' + scope.role
              } else if (userPayload.role.includes('User')) {
                userPayload.role = 'User - ' + scope.role
              } else if (userPayload.role.includes('ContentManager')) {
                userPayload.role = 'ContentManager - ' + scope.role
              }
            }
          })
        }
      })
    }
    return userPayload
  },

  getPreURI: function() {
    var str = '/'
    if (
      window.location.hash.replace('#/', '').split('/')[0] !== '' &&
      window.location.hash.replace('#/', '').split('/')[0] !== 'admin'
    ) {
      str += window.location.hash.replace('#/', '').split('/')[0]
    }
    if (
      window.location.hash.replace('#/', '').split('/')[1] !== 'admin' &&
      window.location.hash.replace('#/', '').split('/')[0] !== 'admin'
    ) {
      str += '/' + window.location.hash.replace('#/', '').split('/')[1]
    }
    if (str === '/') {
      str = ''
    }
    return str
  },

  updateUserAccessAndClusterScope: getAccData => {
    var acc = getAccData.data
    var accArr = []
    for (var i = 0; i < acc.data.access.length; i++) {
      accArr.push(acc.data.access[i])
    }
    acc.data.access = accArr
    let SelectedScope = {}
    let SelectedCluster = { scope_access: [], access_type: RouteAccess.NO_ACCESS }
    for (var i = 0; i < getAccData.data.data.access.length; i++) {
      if (getAccData.data.data.isRoot) {
        SelectedCluster = getAccData.data.data.access[i]
        break
      } else {
        var selectClus = {}
        for (let j = 0; j < getAccData.data.data.access[i].scope_access.length; j++) {
          if (getAccData.data.data.access[i].access_type === RouteAccess.ADMINISTRATOR) {
            selectClus = getAccData.data.data.access[i]
            break
          } else if (
            getAccData.data.data.access[i].scope_access[j].role !== RouteAccess.NO_ACCESS
          ) {
            selectClus = getAccData.data.data.access[i]
            break
          }
        }
        if (Object.keys(selectClus).length > 0) {
          SelectedCluster = selectClus
          break
        }
      }
    }
    var accRole = ''
    var Access = ''
    if (acc.data) {
      let enabledScopelist = acc.data
      let userRolePriority = {
        'No Access': 0,
        Viewer: 1,
        'Security Analyst': 2,
        'Security Engineer': 3,
      }
      let highestRole = ''
      if (
        !enabledScopelist.isRoot &&
        !enabledScopelist.isOrgAdmin &&
        enabledScopelist.userType !== RouteAccess.CONTENT_MNGR_API
      ) {
        if (SelectedCluster.scope_access.length > 0) {
          highestRole = SelectedCluster.scope_access[0]['role']
          if (SelectedCluster.access_type === RouteAccess.ADMINISTRATOR) {
            accRole = `${RouteAccess.USER} - ${RouteAccess.TENANT_ADMIN} - ${SelectedCluster.scope_access[0]['role']}`
            Access = accRole
            SelectedScope = SelectedCluster.scope_access[0]
          } else {
            accRole = `${RouteAccess.USER} - ${SelectedCluster.scope_access[0]['role']}`
            Access = accRole
            SelectedScope = SelectedCluster.scope_access[0]
          }
          for (let j = 0; j < SelectedCluster.scope_access.length; j++) {
            if (
              userRolePriority[highestRole] <
              userRolePriority[SelectedCluster.scope_access[j]['role']]
            ) {
              highestRole = SelectedCluster.scope_access[j]['role']
              if (SelectedCluster.access_type === RouteAccess.ADMINISTRATOR) {
                accRole = `${RouteAccess.USER} - ${RouteAccess.TENANT_ADMIN} - ${SelectedCluster.scope_access[j]['role']}`
                Access = accRole
                SelectedScope = SelectedCluster.scope_access[j]
              } else {
                accRole = `${RouteAccess.USER} - ${SelectedCluster.scope_access[j]['role']}`
                Access = accRole
                SelectedScope = SelectedCluster.scope_access[j]
              }
            }
          }
        } else {
          if (SelectedCluster.access_type === RouteAccess.ADMINISTRATOR) {
            accRole = `${RouteAccess.USER} - ${RouteAccess.TENANT_ADMIN}`
          } else {
            accRole = `${RouteAccess.USER} - ${RouteAccess.NO_ACCESS}`
          }
        }
      } else if (enabledScopelist.isOrgAdmin) {
        if (SelectedCluster.scope_access.length > 0) {
          highestRole = SelectedCluster.scope_access[0]['role']
          if (SelectedCluster.access_type === RouteAccess.ADMINISTRATOR) {
            accRole = `${RouteAccess.ORG_ADMIN} - ${RouteAccess.TENANT_ADMIN} - ${SelectedCluster.scope_access[0]['role']}`
            Access = accRole
            SelectedScope = SelectedCluster.scope_access[0]
          } else {
            accRole = `${RouteAccess.ORG_ADMIN} - ${SelectedCluster.scope_access[0]['role']}`
            Access = accRole
            SelectedScope = SelectedCluster.scope_access[0]
          }
          for (let j = 0; j < SelectedCluster.scope_access.length; j++) {
            if (
              userRolePriority[highestRole] <
              userRolePriority[SelectedCluster.scope_access[j]['role']]
            ) {
              highestRole = SelectedCluster.scope_access[j]['role']
              if (SelectedCluster.access_type === RouteAccess.ADMINISTRATOR) {
                accRole = `${RouteAccess.ORG_ADMIN} - ${RouteAccess.TENANT_ADMIN} - ${SelectedCluster.scope_access[j]['role']}`
                Access = accRole
                SelectedScope = SelectedCluster.scope_access[j]
              } else {
                accRole = `${RouteAccess.ORG_ADMIN} - ${SelectedCluster.scope_access[j]['role']}`
                Access = accRole
                SelectedScope = SelectedCluster.scope_access[j]
              }
            }
          }
        } else {
          if (SelectedCluster.access_type === RouteAccess.ADMINISTRATOR) {
            accRole = `${RouteAccess.ORG_ADMIN} - ${RouteAccess.TENANT_ADMIN}`
          } else {
            accRole = `${RouteAccess.ORG_ADMIN} - ${RouteAccess.NO_ACCESS}`
          }
        }
      } else if (enabledScopelist.userType === RouteAccess.CONTENT_MNGR_API) {
        if (SelectedCluster.scope_access.length > 0) {
          highestRole = SelectedCluster.scope_access[0]['role']
          if (SelectedCluster.access_type === RouteAccess.ADMINISTRATOR) {
            accRole = `${RouteAccess.CONTENT_MNGR} - ${RouteAccess.TENANT_ADMIN} - ${SelectedCluster.scope_access[0]['role']}`
            Access = accRole
            SelectedScope = SelectedCluster.scope_access[0]
          } else {
            accRole = `${RouteAccess.CONTENT_MNGR} - ${SelectedCluster.scope_access[0]['role']}`
            Access = accRole
            SelectedScope = SelectedCluster.scope_access[0]
          }
          for (let j = 0; j < SelectedCluster.scope_access.length; j++) {
            if (
              userRolePriority[highestRole] <
              userRolePriority[SelectedCluster.scope_access[j]['role']]
            ) {
              highestRole = SelectedCluster.scope_access[j]['role']
              if (SelectedCluster.access_type === RouteAccess.ADMINISTRATOR) {
                accRole = `${RouteAccess.CONTENT_MNGR} - ${RouteAccess.TENANT_ADMIN} - ${SelectedCluster.scope_access[j]['role']}`
                Access = accRole
                SelectedScope = SelectedCluster.scope_access[j]
              } else {
                accRole = `${RouteAccess.CONTENT_MNGR} - ${SelectedCluster.scope_access[j]['role']}`
                Access = accRole
                SelectedScope = SelectedCluster.scope_access[j]
              }
            }
          }
        } else {
          if (SelectedCluster.access_type === RouteAccess.ADMINISTRATOR) {
            accRole = `${RouteAccess.CONTENT_MNGR} - ${RouteAccess.TENANT_ADMIN}`
          } else {
            accRole = `${RouteAccess.CONTENT_MNGR} - ${RouteAccess.NO_ACCESS}`
          }
        }
      } else {
        if (SelectedCluster.scope_access.length > 0) {
          highestRole = SelectedCluster.scope_access[0]['role']
          if (SelectedCluster.access_type === RouteAccess.ADMINISTRATOR) {
            accRole = `${RouteAccess.ROOT} - ${RouteAccess.TENANT_ADMIN} - ${SelectedCluster.scope_access[0]['role']}`
            Access = accRole
            SelectedScope = SelectedCluster.scope_access[0]
          } else {
            accRole = `${RouteAccess.ROOT} - ${SelectedCluster.scope_access[0]['role']}`
            Access = accRole
            SelectedScope = SelectedCluster.scope_access[0]
          }
          for (let j = 0; j < SelectedCluster.scope_access.length; j++) {
            if (
              userRolePriority[highestRole] <
              userRolePriority[SelectedCluster.scope_access[j]['role']]
            ) {
              highestRole = SelectedCluster.scope_access[j]['role']
              if (SelectedCluster.access_type === RouteAccess.ADMINISTRATOR) {
                accRole = `${RouteAccess.ROOT} - ${RouteAccess.TENANT_ADMIN} - ${SelectedCluster.scope_access[j]['role']}`
                Access = accRole
                SelectedScope = SelectedCluster.scope_access[j]
              } else {
                accRole = `${RouteAccess.ROOT} - ${SelectedCluster.scope_access[j]['role']}`
                Access = accRole
                SelectedScope = SelectedCluster.scope_access[j]
              }
            }
          }
        } else {
          if (SelectedCluster.access_type === RouteAccess.ADMINISTRATOR) {
            accRole = `${RouteAccess.ROOT} - ${RouteAccess.TENANT_ADMIN}`
          } else {
            accRole = `${RouteAccess.ROOT} - ${RouteAccess.NO_ACCESS}`
          }
        }
      }
    }
    localStorage.setItem('UserAcc', accRole)
    const userPayload = JSON.parse(localStorage.getItem('userPayload'))
    userPayload.licenseType =
      Object.keys(SelectedCluster).length > 0 ? SelectedCluster.licenseType : ''
    userPayload.clusterId = Object.keys(SelectedCluster).length > 0 ? SelectedCluster.clusterId : ''
    userPayload.scope_id = Object.keys(SelectedScope).length > 0 ? SelectedScope.scope_id : ''
    userPayload.selectedCluster = SelectedCluster
    userPayload.selectedScope = SelectedScope
    userPayload.AllAccessData = getAccData.data
    userPayload.role = accRole

    localStorage.setItem('userPayload', JSON.stringify(userPayload))

    // window.location.reload(false)

    // this.props.updateAcc(dat)

    const history = createHashHistory()
    localStorage.setItem('userPayload', JSON.stringify(userPayload))
    var historyURLpath = localStorage.getItem('historyURL')
    if (Object.keys(SelectedCluster).length > 0 || Object.keys(SelectedScope).length > 0) {
      var scopeID = Object.keys(SelectedScope).length > 0 ? '/' + SelectedScope.scope_id : ''
      if (!RouteAccess.USER_NO_ACCESS_ROLES.includes(accRole)) {
        if (RouteAccess.ROOT_INIT_ROLES.includes(accRole)) {
          path = '/admin/tenants/list'
        } else if (RouteAccess.ROOT_NO_ACCESS_ROLES.includes(accRole)) {
          path = '/' + SelectedCluster.clusterId + scopeID + '/admin/tenants/list'
        } else if (RouteAccess.ORG_ADMIN_NO_ACCESS_ROLES.includes(accRole)) {
          path = '/admin/organizations/list'
        } else if (RouteAccess.CONTENT_MNGR_NO_ACCESS_ROLES.includes(accRole)) {
          path = '/' + SelectedCluster.clusterId + scopeID + '/system/streamfieldaddition'
        } else if (RouteAccess.ONLY_TENANT_ADMIN_ROLES.includes(accRole)) {
          path = '/' + SelectedCluster.clusterId + scopeID + '/admin/tenants/list'
        } else if (RouteAccess.VIEWER_ROLES.includes(accRole)) {
          path = '/' + SelectedCluster.clusterId + scopeID + '/dashboard'
        } else {
          var path =
            '/' +
            SelectedCluster.clusterId +
            scopeID +
            '/home' +
            scopeID +
            '/' +
            SelectedCluster.clusterId
        }
      } else {
        path = '/no-access/auth/no-access'
      }
    } else {
      path = '/no-access/auth/no-access'
    }
    if (history.location.pathname !== path) {
      history.push(path)
      window.location.reload(false)
    }
  },

  UpdateUI_withNewAccess: function() {
    const history = createHashHistory()
    var data = { ssid: localStorage.getItem('SSID') }
    if (localStorage.getItem('SSID') !== null) {
      Scopes.getUserAccessDetails(data, localStorage.getItem('SSID'))
        .then(response => {
          if (
            response.data.status === 'invalid' ||
            (response.data.status === 'error' &&
              (response.data.message === 'User Invalid' || response.data.message === 'Invalid'))
          ) {
            Common.sessionExpiry('access')
          }
          if (response.data.status === 'success') {
            var getAccData = response
            if (
              localStorage.getItem('UserAcc').includes('Root - ') ||
              localStorage.getItem('UserAcc').includes(`${RouteAccess.CONTENT_MNGR} - `) ||
              (getAccData.data.data?.access?.length > 0 &&
                getAccData.data.data.access.filter(d => d.access_type === 'Administrator').length >
                  0)
            ) {
              let params = {
                size: 1000,
                query: '',
                add_filter: [],
                page: 1,
              }
              ClusterService.getTenantList(localStorage.getItem('SSID'), params)
                .then(response => {
                  if (
                    response.data.status === 'invalid' ||
                    (response.data.status === 'error' &&
                      (response.data.message === 'User Invalid' ||
                        response.data.message === 'Invalid'))
                  ) {
                    Common.sessionExpiry('access')
                  }
                  if (response.data.status === 'success') {
                    if (response.data.data.length === 0) {
                      // accRole = `${RouteAccess.ROOT} - ${RouteAccess.INIT}` // No tenants created yet so redirect Root user
                    } // with the 'Root - Init' access to  tenants list page to create a first tenant.
                    else {
                      // create a access object to process further
                      var accessMap = {}
                      if (getAccData.data?.data?.access?.length > 0) {
                        getAccData.data.data.access.map(d => (accessMap[d.clusterId] = d))
                      } else if (
                        localStorage.getItem('UserAcc').includes(`${RouteAccess.ROOT} - `)
                      ) {
                        getAccData.data.data.isRoot = true
                      } else {
                        getAccData.data.data.userType = RouteAccess.CONTENT_MNGR_API
                      }
                      let tmpAccessList = []
                      let tenantsAccessMap = {}
                      for (let i = 0; i < response.data.data.length; i++) {
                        let d = response.data.data[i]
                        let accessDetails = {
                          access_type: accessMap[d['clusterId']]
                            ? accessMap[d['clusterId']].access_type
                            : 'No Access',
                          clusterId: d['clusterId'],
                          clusterName: d['clusterName'],
                          licenseType: d['licenseType'] ? d['licenseType'] : '',
                          productType: d['productType'] ? d['productType'] : '',
                          scope_access: d.scope_list
                            .filter(d => d.is_enabled)
                            .map(d => {
                              let tmpScopeD = {
                                scope_id: d.scope_id,
                                scope_name: d.scope_name,
                                role: 'No Access',
                              }
                              if (accessMap[d['cluster_id']]?.scope_access?.length > 0) {
                                accessMap[d['cluster_id']].scope_access.map(d1 => {
                                  if (d1.scope_id === d.scope_id) {
                                    tmpScopeD.role = d1.role
                                  }
                                })
                              }
                              return tmpScopeD
                            }),
                        }
                        tenantsAccessMap[d.clusterId] = d
                        tmpAccessList.push(accessDetails)
                      }
                      if (getAccData.data.data?.access?.length > 0) {
                        getAccData.data.data.access.map(d => {
                          if (!tenantsAccessMap[d.clusterId]) {
                            tmpAccessList.push(d)
                          }
                        })
                      }
                      getAccData.data.data.access = tmpAccessList
                      this.updateUserAccessAndClusterScope(getAccData)
                    }
                  }
                  if (response.data.status === 'failed') {
                    if (response.data.message === 'user not authorised') {
                      // Common.showNotifications(
                      //   'error',
                      //   <div>You have no rights to access this page.</div>,
                      // )
                      Common.sessionExpiry()
                    }
                    Common.showNotifications('error', 'Connections failed')
                  }
                })
                .catch(error => {
                  if (error.response !== undefined && error.response !== 'undefined') {
                    if (
                      error.response.data.status === 'invalid' ||
                      (error.response.data.status === 'error' &&
                        error.response.data.message.indexOf('Invalid') > -1)
                    ) {
                      Common.sessionExpiry('access')
                    }
                  }
                  Common.showNotifications('error', 'Something went wrong')
                })
            } else {
              if (getAccData.data.data?.access?.length > 0) {
                this.updateUserAccessAndClusterScope(getAccData)
              }
            }
          }
          if (response.data.status === 'failed') {
            if (response.data.message === 'user not authorised') {
              // Common.showNotifications('error', <div>You have no rights to access this page.</div>)
              Common.sessionExpiry()
            }
            Common.showNotifications('error', 'Connections failed')
          }
        })
        .catch(error => {
          if (error.response !== undefined && error.response !== 'undefined') {
            if (
              error.response.data.status === 'invalid' ||
              (error.response.data.status === 'error' &&
                error.response.data.message.indexOf('Invalid') > -1)
            ) {
              Common.sessionExpiry('access')
            }
          }
          Common.showNotifications('error', 'Something went wrong')
        })
    }
  },

  checkSessionExpiry: function() {
    let ssid = localStorage.getItem('SSID')
    var data = { ssid: ssid }
    Scopes.getUserAccessDetails(data, ssid)
      .then(response => {
        if (
          response.data.status === 'invalid' ||
          (response.data.status === 'error' &&
            (response.data.message === 'User Invalid' || response.data.message === 'Invalid'))
        ) {
          Common.sessionExpiry('access')
        }
      })
      .catch(error => {
        if (error.response !== undefined && error.response !== 'undefined') {
          if (
            error.response.data.status === 'invalid' ||
            (error.response.data.status === 'error' &&
              error.response.data.message.indexOf('Invalid') > -1)
          ) {
            Common.sessionExpiry('access')
          }
        }
      })
  },

  searchList: function(params, ssid, clusterId) {
    return axios.post(Conf.HOST_S + Conf.CORE_IP2 + '/' + clusterId + '/api/search', params, {
      headers: {
        SSID: ssid,
      },
    })
  },

  usersList: function(params, ssid, clusterId) {
    return axios.post(Conf.HOST + Conf.CORE_IP + '/' + clusterId + '/api/users/list', params, {
      headers: { SSID: ssid },
    })
  },

  exportList: function(params, ssid, clusterId) {
    return axios.post(Conf.HOST + Conf.CORE_IP + '/' + clusterId + '/api/export_list', params, {
      headers: { SSID: ssid },
    })
  },
}
export default Common
